import * as React from 'react'
import {
  BooleanField,
  BooleanInput,
  Create,
  Datagrid,
  DeleteButton,
  Edit,
  EditButton,
  List,
  NumberField,
  NumberInput,
  required,
  SimpleForm,
  TextField,
  TextInput,
} from 'react-admin'
import { Typography } from '@mui/material'

// The broad categories offered for each contract's Categorisation field.
// Defaults to the five domains in the AI Contract Repository Proposal.
const Explanation = () => (
  <Typography variant="body2" sx={{ m: 2, mb: 0 }}>
    The categories SpendQube can choose from for each contract&apos;s
    Categorisation field. Inactive categories are kept but not offered.
    Contracts that fit none are left blank for review.
  </Typography>
)

export const ContractCategorisationList = () => (
  <List
    sort={{ field: 'position', order: 'ASC' }}
    pagination={false}
    perPage={100}
    title="Contract Categorisation"
  >
    <Explanation />
    <Datagrid bulkActionButtons={false}>
      <NumberField source="position" label="Order" />
      <TextField source="name" />
      <BooleanField source="is_active" label="Active" />
      <EditButton />
      <DeleteButton mutationMode="pessimistic" />
    </Datagrid>
  </List>
)

const CategorisationForm = () => (
  <SimpleForm>
    <TextInput source="name" validate={required()} fullWidth />
    <NumberInput source="position" label="Order" />
    <BooleanInput source="is_active" label="Active" defaultValue />
  </SimpleForm>
)

export const ContractCategorisationCreate = () => (
  <Create redirect="list" title="New contract category">
    <CategorisationForm />
  </Create>
)

export const ContractCategorisationEdit = () => (
  <Edit
    mutationMode="pessimistic"
    redirect="list"
    title="Edit contract category"
  >
    <CategorisationForm />
  </Edit>
)
